import { render } from "./succeed.vue?vue&type=template&id=e80db016&scoped=true"
import script from "./succeed.vue?vue&type=script&lang=js"
export * from "./succeed.vue?vue&type=script&lang=js"

import "./succeed.vue?vue&type=style&index=0&id=e80db016&scoped=true&lang=scss"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80db016"]])

export default __exports__